import { printHTML, downloadWord } from '../utils/printHelper';
import { useEffect, useState } from 'react';
import { api } from '../App';
import { toast } from 'sonner';
import { formatDatePrint } from '../utils/dateFormat';
import { DateInput } from '../components/DateInput';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { Card } from '@/components/ui/card';
import { Plus, Pencil, Trash, Printer, FileDoc, Storefront } from '@phosphor-icons/react';
import { confirmDialog } from '@/components/ConfirmDialog';
import ClientAutocomplete from '../components/ClientAutocomplete';

const VRSTA_TYPE = 'ctr_restoran';

const EMPTY = {
  vrsta_zahtjeva: VRSTA_TYPE,
  client_id: '',
  datum_podnosenja: new Date().toISOString().split('T')[0],
  // Vrsta i datum unosa
  ctrr_vrsta_unosa: 'upis', // 'upis' | 'promjena' | 'prestanak'
  ctrr_datum_unosa: '',
  ctrr_broj_upisa: '',
  // Vrsta objekta
  ctrr_vrsta_objekta: '', ctrr_naziv_objekta: '', ctrr_club_oznaka: false,
  // Pravno lice / preduzetnik
  ctrr_oblik: 'doo', // preduzetnik | komanditno | doo | ortacko | ad | dio_stranog
  ctrr_pretezna_sifra: '', ctrr_pretezna_naziv: '',
  ctrr_crps_broj: '', ctrr_crps_datum: '',
  ctrr_naziv_sjediste: '', ctrr_maticni_broj: '',
  ctrr_ulica_broj: '', ctrr_opstina_drzava: '',
  // Odgovorno lice (firma)
  ctrr_odg_ime: '', ctrr_odg_jmb: '',
  ctrr_odg_dok_vrsta: '', ctrr_odg_dok_broj: '', ctrr_odg_dok_drzava: '',
  ctrr_odg_kontakt: '',
  // Preduzetnik
  ctrr_pred_ime: '', ctrr_pred_jmb: '', ctrr_pred_pol: 'M',
  ctrr_pred_dok_vrsta: '', ctrr_pred_dok_broj: '', ctrr_pred_dok_drzava: '',
  ctrr_pred_ulica_broj: '', ctrr_pred_opstina_drzava: '', ctrr_pred_kontakt: '',
  // Podaci o objektu
  ctrr_osnov: 'svojina', // svojina | zakup | drugi
  ctrr_osnov_drugi: '',
  ctrr_obj_ulica_broj: '', ctrr_obj_opstina_mjesto: '',
  ctrr_kat_opstina: '', ctrr_kat_parcela: '', ctrr_kat_lokacija: '', ctrr_povrsina: '',
  // Lokacija/mjesto
  ctrr_lok_grad: false, ctrr_lok_prigrad: false, ctrr_lok_plaza: false,
  ctrr_lok_skijaliste: false, ctrr_lok_nacionalni_park: false, ctrr_lok_ostalo: '',
  // Odgovorno lice u objektu
  ctrr_odg_obj_ime: '', ctrr_odg_obj_jmb: '', ctrr_odg_obj_pol: 'M',
  ctrr_odg_obj_dok_vrsta: '', ctrr_odg_obj_dok_broj: '', ctrr_odg_obj_dok_drzava: '',
  ctrr_odg_obj_kontakt: '',
  // Broj zaposlenih
  ctrr_zap_zene_stalno: '', ctrr_zap_musk_stalno: '', ctrr_zap_uk_stalno: '',
  ctrr_zap_zene_povr: '', ctrr_zap_musk_povr: '', ctrr_zap_uk_povr: '',
  // Period rada
  ctrr_period_cijela_godina: false, ctrr_period_sezonski_ljeti: false, ctrr_period_sezonski_zimi: false,
  // Kapacitet — prostor
  ctrr_prostor_zatvoreni: '', ctrr_prostor_otvoreni: '', ctrr_prostor_ostalo: '',
  ctrr_konzumna_mjesta: '',
  // Sadržaji
  ctrr_vinoteka: false, ctrr_vinoteka_broj: '', ctrr_vinoteka_kap: '',
  ctrr_sank_bar: false, ctrr_sank_bar_broj: '', ctrr_sank_bar_kap: '',
  ctrr_sadrzaj_djeca: false, ctrr_sadrzaj_djeca_broj: '', ctrr_sadrzaj_djeca_kap: '',
  ctrr_sadrzaj_ostalo: '', ctrr_sadrzaj_ostalo_broj: '', ctrr_sadrzaj_ostalo_kap: '',
  // Parking
  ctrr_park_otvoreni: '', ctrr_park_natkriveni: '', ctrr_park_garaza: '', ctrr_park_neobiljezeni: '',
  // Rješenje (popunjava organ)
  ctrr_naziv_organa: '', ctrr_broj_rjesenja: '', ctrr_datum_rjesenja: '', ctrr_vazi_do: '',
  // Kategorizacija
  ctrr_kat_broj: '', ctrr_kat_datum: '', ctrr_kat_rok: '', ctrr_kat_nivo: '',
  // Ćutanje administracije
  ctrr_obavjestenje_broj: '', ctrr_obavjestenje_datum: '',
  // Napomena + potpis
  napomena: '',
  ctrr_mjesto: '',
  ctrr_lice_odgovorno: '',
  status: 'nacrt',
};

export default function CTRRestoraniPage() {
  const [list, setList] = useState([]);
  const [clients, setClients] = useState([]);
  const [open, setOpen] = useState(false);
  const [editing, setEditing] = useState(null);
  const [form, setForm] = useState(EMPTY);
  const [search, setSearch] = useState('');

  useEffect(() => { load(); api.get('/clients').then(r => setClients(r.data)).catch(() => {}); }, []);

  const load = async () => {
    try {
      const r = await api.get('/zahtjevi', { params: { vrsta: VRSTA_TYPE } });
      setList(r.data || []);
    } catch (e) { toast.error('Greška'); }
  };

  const handleSave = async () => {
    try {
      const data = { ...form, vrsta_zahtjeva: VRSTA_TYPE };
      if (editing) await api.put(`/zahtjevi/${editing.id}`, data);
      else await api.post('/zahtjevi', data);
      toast.success(editing ? 'Sačuvano' : 'Kreirano');
      setOpen(false); setEditing(null); setForm(EMPTY); load();
    } catch (e) { toast.error('Greška: ' + (e.response?.data?.detail || e.message)); }
  };

  const handleEdit = (z) => {
    setEditing(z);
    setForm({ ...EMPTY, ...z });
    setOpen(true);
  };

  const handleDelete = async (z) => {
    const ok = await confirmDialog({ title: 'Obrisati?', message: `Obrisati zahtjev za "${z.ctrr_naziv_objekta || 'CTR Restoran'}"?` });
    if (!ok) return;
    try { await api.delete(`/zahtjevi/${z.id}`); toast.success('Obrisano'); load(); } catch (e) { toast.error('Greška'); }
  };

  // Auto-popuna iz klijenta
  const onClientChange = (client_id) => {
    const c = clients.find(x => x.id === client_id);
    if (!c) { setForm({ ...form, client_id }); return; }
    setForm({
      ...form,
      client_id,
      ctrr_naziv_sjediste: c.naziv_firme || c.skraceni_naziv || '',
      ctrr_maticni_broj: c.pib || '',
      ctrr_ulica_broj: c.adresa || '',
      ctrr_opstina_drzava: c.opstina || '',
      ctrr_odg_ime: c.direktor || '',
      ctrr_odg_jmb: c.jmb_direktora || '',
      ctrr_odg_kontakt: (c.telefon || '') + (c.email ? ` / ${c.email}` : ''),
      ctrr_pretezna_sifra: c.sifra_djelatnosti || '',
      ctrr_pretezna_naziv: c.djelatnost || '',
    });
  };

  // ========== PRINT ==========
  const cb = (v) => v ? '☒' : '☐';

  const buildHtml = (z) => {
    const oblikText = {
      preduzetnik: 'Preduzetnik',
      komanditno: 'Komanditno društvo',
      doo: 'Društvo sa ograničenom odgovornošću (D.O.O.)',
      ortacko: 'Ortačko društvo',
      ad: 'Akcionarsko društvo (A.D.)',
      dio_stranog: 'Dio stranog društva',
    };

    return `<!DOCTYPE html><html><head><meta charset="utf-8"><title>CTR Restorani</title>
<style>
@page { size: A4; margin: 12mm 14mm; }
* { box-sizing: border-box; }
body { font-family: 'Times New Roman', serif; font-size: 9.5pt; color:#000; line-height: 1.3; margin:0; padding:0; }
.title { text-align: center; font-weight: bold; font-size: 11pt; margin: 0 0 3px 0; line-height: 1.25; }
.subtitle { text-align: center; font-size: 8.5pt; margin: 0 0 8px 0; font-style: italic; }
table { width:100%; border-collapse: collapse; }
td { border: 1px solid #000; padding: 3px 5px; vertical-align: top; }
.shaded { background: #d9d9d9; }
.section { background: #cfd9e8; font-weight: bold; text-align: center; padding: 3px 5px; border: 1px solid #000; margin-top: 4px; font-size: 9.5pt; }
.lbl { font-weight: bold; }
.note { font-size: 8pt; font-style: italic; padding: 2px 5px; border: 1px solid #000; border-top: none; }
.cb-grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 2px; padding: 4px 8px; }
.cb { font-size: 9pt; }
.row-cells { display: flex; }
.row-cells > div { flex: 1; padding: 3px 5px; border: 1px solid #000; }
.sig-area { margin-top: 14px; }
.sig-row { display: flex; justify-content: space-between; align-items: end; margin-top: 25px; }
.sig-line { border-bottom: 1px solid #000; min-width: 220px; padding: 0 4px; text-align: center; }
.small { font-size: 8pt; }
@media print { body { margin: 0; } }
</style></head><body>

<div class="title">UGOSTITELJSKI OBJEKTI ZA PRUŽANJE USLUGA PRIPREMANJA I USLUŽIVANJA HRANE, PIĆA I NAPITAKA – RESTORAN/BAR/PICERIJA/KONOBA...</div>
<div class="subtitle">Popunjavanje obrasca: podaci se unose: tekstom (VELIKIM, ŠTAMPANIM SLOVIMA), oznakom „x" u polje ili zaokruživanjem polja</div>
<div class="small" style="margin-bottom:6px">- podatke u neosjenčena polja unosi podnosilac zahtjeva za izdavanje odobrenja za obavljanje ugostiteljske djelatnosti<br>- podatke u osjenčena polja unosi organ državne uprave nadležan za poslove turizma / nadležni organ lokalne uprave</div>

<table>
  <tr>
    <td style="width:35%" class="lbl">Vrsta i datum unosa podataka u Centralni turistički registar:*</td>
    <td>
      <div>${cb(z.ctrr_vrsta_unosa==='upis')} upis podataka: ${z.ctrr_vrsta_unosa==='upis'?formatDatePrint(z.ctrr_datum_unosa):'____'} godine</div>
      <div>${cb(z.ctrr_vrsta_unosa==='promjena')} promjena / dopuna podataka: ${z.ctrr_vrsta_unosa==='promjena'?formatDatePrint(z.ctrr_datum_unosa):'____'} godine</div>
      <div>${cb(z.ctrr_vrsta_unosa==='prestanak')} prestanak važenja rješenja: ${z.ctrr_vrsta_unosa==='prestanak'?formatDatePrint(z.ctrr_datum_unosa):'____'} godine</div>
    </td>
  </tr>
</table>
<div class="note">*popunjava organ državne uprave nadležan za poslove turizma / nadležni organ lokalne uprave</div>

<table style="margin-top:4px">
  <tr><td class="lbl shaded" style="width:35%">Broj upisa u Centralni turistički registar:*</td><td class="shaded">${z.ctrr_broj_upisa||'&nbsp;'}</td></tr>
</table>
<div class="note">*popunjava organ državne uprave nadležan za poslove turizma / nadležni organ lokalne uprave</div>

<table style="margin-top:6px">
  <tr><td class="lbl" style="width:30%">VRSTA OBJEKTA:*</td><td>${z.ctrr_vrsta_objekta||'&nbsp;'}</td></tr>
  <tr><td class="lbl">NAZIV OBJEKTA:</td><td>${z.ctrr_naziv_objekta||'&nbsp;'}</td></tr>
  <tr><td class="lbl">"Club" oznaka:</td><td>${cb(z.ctrr_club_oznaka)} Da &nbsp;&nbsp; ${cb(!z.ctrr_club_oznaka)} Ne</td></tr>
</table>
<div class="note">*restoran (nacionalni/klasični/specijalizovani i dr.), bar, kafić, picerija...</div>

<div class="section">PODACI O PRIVREDNOM DRUŠTVU, DRUGOM PRAVNOM LICU, PREDUZETNIKU</div>
<table>
  <tr>
    <td class="lbl" style="width:30%">Oblik obavljanja privredne djelatnosti:</td>
    <td>
      <div class="cb-grid">
        <div class="cb">${cb(z.ctrr_oblik==='preduzetnik')} Preduzetnik</div>
        <div class="cb">${cb(z.ctrr_oblik==='komanditno')} Komanditno društvo</div>
        <div class="cb">${cb(z.ctrr_oblik==='doo')} Društvo sa ograničenom odgovornošću (D.O.O.)</div>
        <div class="cb">${cb(z.ctrr_oblik==='ortacko')} Ortačko društvo</div>
        <div class="cb">${cb(z.ctrr_oblik==='ad')} Akcionarsko društvo (A.D.)</div>
        <div class="cb">${cb(z.ctrr_oblik==='dio_stranog')} Dio stranog društva</div>
      </div>
    </td>
  </tr>
  <tr>
    <td class="lbl">Pretežna djelatnost:*</td>
    <td>Šifra: ${z.ctrr_pretezna_sifra||'_____'} &nbsp;&nbsp; Naziv: ${z.ctrr_pretezna_naziv||'_____'}</td>
  </tr>
  <tr class="shaded">
    <td class="lbl shaded">Upis u CRPS*:</td>
    <td class="shaded">Broj: ${z.ctrr_crps_broj||'_____'} &nbsp;&nbsp; Datum: ${formatDatePrint(z.ctrr_crps_datum)||'_____'}</td>
  </tr>
</table>
<div class="note">*popunjava organ državne uprave nadležan za poslove turizma/nadležni organ lokalne uprave</div>

<div class="section">Popunjava ovlašćeni predstavnik privrednog društva ili drugog pravnog lica:</div>
<table>
  <tr>
    <td class="lbl" style="width:30%">Naziv i sjedište:</td>
    <td>
      Naziv: ${z.ctrr_naziv_sjediste||'_____'} &nbsp;&nbsp; Matični broj*: ${z.ctrr_maticni_broj||'_____'}<br>
      Ulica i broj: ${z.ctrr_ulica_broj||'_____'} &nbsp;&nbsp; Opština i država: ${z.ctrr_opstina_drzava||'_____'}
    </td>
  </tr>
  <tr>
    <td class="lbl">Odgovorno lice:</td>
    <td>
      Ime i prezime: ${z.ctrr_odg_ime||'_____'} &nbsp;&nbsp; JMB: ${z.ctrr_odg_jmb||'_____'}<br>
      Identifikacioni dokument**: Vrsta: ${z.ctrr_odg_dok_vrsta||'____'} &nbsp; Broj: ${z.ctrr_odg_dok_broj||'____'} &nbsp; Država izdavanja: ${z.ctrr_odg_dok_drzava||'____'}<br>
      Kontakt telefon/E-mail: ${z.ctrr_odg_kontakt||'_____'}
    </td>
  </tr>
</table>
<div class="note">* osmocifreni broj određen od strane MONSTAT-a &nbsp;&nbsp; ** za strane državljane</div>

<div class="section">Popunjava preduzetnik:</div>
<table>
  <tr>
    <td class="lbl" style="width:30%">Ime i adresa:</td>
    <td>
      Ime i prezime: ${z.ctrr_pred_ime||'_____'} &nbsp;&nbsp; JMB: ${z.ctrr_pred_jmb||'_____'} &nbsp;&nbsp; Pol: ${z.ctrr_pred_pol==='Z'?'<u>Ž</u>':'Ž'} ${z.ctrr_pred_pol==='M'?'<u>M</u>':'M'}<br>
      Identifikacioni dokument*: Vrsta: ${z.ctrr_pred_dok_vrsta||'____'} &nbsp; Broj: ${z.ctrr_pred_dok_broj||'____'} &nbsp; Država izdavanja: ${z.ctrr_pred_dok_drzava||'____'}<br>
      Ulica i broj: ${z.ctrr_pred_ulica_broj||'____'} &nbsp;&nbsp; Opština i država: ${z.ctrr_pred_opstina_drzava||'____'}<br>
      Kontakt telefon/e-mail: ${z.ctrr_pred_kontakt||'_____'}
    </td>
  </tr>
</table>
<div class="note">*za strane državljane</div>

<div class="section">PODACI O OBJEKTU:</div>
<table>
  <tr>
    <td class="lbl" style="width:30%">Osnov prava korišćenja:</td>
    <td>
      ${cb(z.ctrr_osnov==='svojina')} Svojina &nbsp;&nbsp; ${cb(z.ctrr_osnov==='zakup')} Zakup &nbsp;&nbsp; ${cb(z.ctrr_osnov==='drugi')} Drugi pravni osnov<br>
      Navesti osnov: ${z.ctrr_osnov_drugi||'_____'}
    </td>
  </tr>
  <tr>
    <td class="lbl">Adresa objekta:</td>
    <td>Ulica i broj: ${z.ctrr_obj_ulica_broj||'____'} &nbsp;&nbsp; Opština i mjesto: ${z.ctrr_obj_opstina_mjesto||'____'}</td>
  </tr>
  <tr class="shaded">
    <td class="lbl shaded">Kat. opština / parcela:</td>
    <td class="shaded">Kat. opština: ${z.ctrr_kat_opstina||'____'} &nbsp; Broj kat. parcele: ${z.ctrr_kat_parcela||'____'} &nbsp; Kat. lokacija: ${z.ctrr_kat_lokacija||'____'} &nbsp; Površina: ${z.ctrr_povrsina||'____'}</td>
  </tr>
  <tr>
    <td class="lbl">Lokacija/mjesto</td>
    <td>
      ${cb(z.ctrr_lok_grad)} U gradu &nbsp;&nbsp;
      ${cb(z.ctrr_lok_prigrad)} U prigradskom području &nbsp;&nbsp;
      ${cb(z.ctrr_lok_plaza)} U blizini plaže &nbsp;&nbsp;
      ${cb(z.ctrr_lok_skijaliste)} U blizini skijališta &nbsp;&nbsp;
      ${cb(z.ctrr_lok_nacionalni_park)} U blizini nacionalnog parka<br>
      Ostalo:* ${z.ctrr_lok_ostalo||'____'}
    </td>
  </tr>
  <tr>
    <td class="lbl">Odgovorno lice u objektu:</td>
    <td>
      Ime i prezime: ${z.ctrr_odg_obj_ime||'____'} &nbsp;&nbsp; JMB: ${z.ctrr_odg_obj_jmb||'____'} &nbsp;&nbsp; Pol: ${z.ctrr_odg_obj_pol==='Z'?'<u>Ž</u>':'Ž'} ${z.ctrr_odg_obj_pol==='M'?'<u>M</u>':'M'}<br>
      Identifikacioni dokument*: Vrsta: ${z.ctrr_odg_obj_dok_vrsta||'____'} &nbsp; Broj: ${z.ctrr_odg_obj_dok_broj||'____'} &nbsp; Država izdavanja: ${z.ctrr_odg_obj_dok_drzava||'____'}<br>
      Kontakt telefon/E-mail: ${z.ctrr_odg_obj_kontakt||'____'}
    </td>
  </tr>
</table>
<div class="note">*za strane državljane &nbsp;&nbsp; *upisati lokaciju</div>

<table style="margin-top:6px">
  <tr>
    <td class="lbl" style="width:30%">Broj zaposlenih lica:</td>
    <td>
      <table style="border:none">
        <tr style="background:#eee"><td>Stalno:</td><td>žene: ${z.ctrr_zap_zene_stalno||'__'}</td><td>muškarci: ${z.ctrr_zap_musk_stalno||'__'}</td><td>ukupno: ${z.ctrr_zap_uk_stalno||'__'}</td></tr>
        <tr><td>Povremeno:</td><td>žene: ${z.ctrr_zap_zene_povr||'__'}</td><td>muškarci: ${z.ctrr_zap_musk_povr||'__'}</td><td>ukupno: ${z.ctrr_zap_uk_povr||'__'}</td></tr>
      </table>
    </td>
  </tr>
  <tr>
    <td class="lbl">Period rada:</td>
    <td>
      ${cb(z.ctrr_period_cijela_godina)} Tokom cijele godine &nbsp;&nbsp;
      ${cb(z.ctrr_period_sezonski_ljeti)} Sezonski - ljeti &nbsp;&nbsp;
      ${cb(z.ctrr_period_sezonski_zimi)} Sezonski - zimi
    </td>
  </tr>
</table>

<div class="section">Kapacitet:</div>
<table>
  <tr>
    <td class="lbl" style="width:30%">Prostor:</td>
    <td>
      Zatvoreni: ${z.ctrr_prostor_zatvoreni||'____'} &nbsp;&nbsp;
      Otvoreni (terasa/bašta i sl.): ${z.ctrr_prostor_otvoreni||'____'}<br>
      Ostalo:* ${z.ctrr_prostor_ostalo||'____'}
    </td>
  </tr>
  <tr>
    <td class="lbl">Broj konzumnih mjesta:</td>
    <td>${z.ctrr_konzumna_mjesta||'____'}</td>
  </tr>
</table>
<div class="note">*upisati oblik prostora</div>

<table style="margin-top:6px">
  <tr style="background:#eee"><td class="lbl" style="width:30%">Sadržaji:</td><td><b>Broj:</b></td><td><b>Kapacitet/veličina:*</b></td></tr>
  <tr><td>Vinoteka: ${cb(z.ctrr_vinoteka)} Da ${cb(!z.ctrr_vinoteka)} Ne</td><td>${z.ctrr_vinoteka_broj||'__'}</td><td>${z.ctrr_vinoteka_kap||'__'}</td></tr>
  <tr><td>Šank bar: ${cb(z.ctrr_sank_bar)} Da ${cb(!z.ctrr_sank_bar)} Ne</td><td>${z.ctrr_sank_bar_broj||'__'}</td><td>${z.ctrr_sank_bar_kap||'__'}</td></tr>
  <tr><td>Sadržaji za djecu: ${cb(z.ctrr_sadrzaj_djeca)} Da ${cb(!z.ctrr_sadrzaj_djeca)} Ne</td><td>${z.ctrr_sadrzaj_djeca_broj||'__'}</td><td>${z.ctrr_sadrzaj_djeca_kap||'__'}</td></tr>
  <tr><td>Ostalo**: ${z.ctrr_sadrzaj_ostalo||'____'}</td><td>${z.ctrr_sadrzaj_ostalo_broj||'__'}</td><td>${z.ctrr_sadrzaj_ostalo_kap||'__'}</td></tr>
</table>
<div class="note">*broj sjedećih mjesta/veličina i sl. &nbsp;&nbsp; ** upisati ostale sadržaje</div>

<table style="margin-top:6px">
  <tr><td class="lbl" style="width:30%">Parking prostor:</td>
    <td><b>Vrsta:</b></td>
    <td><b>Kapacitet/broj mjesta:</b></td></tr>
  <tr><td></td><td>Otvoreni</td><td>${z.ctrr_park_otvoreni||'____'}</td></tr>
  <tr><td></td><td>Natkriveni</td><td>${z.ctrr_park_natkriveni||'____'}</td></tr>
  <tr><td></td><td>Garaža</td><td>${z.ctrr_park_garaza||'____'}</td></tr>
  <tr><td></td><td>Neobiljezeni</td><td>${z.ctrr_park_neobiljezeni||'____'}</td></tr>
</table>

<div class="section shaded" style="background:#bdbdbd">RJEŠENJE O ODOBRENJU ZA OBAVLJANJE UGOSTITELJSKE DJELATNOSTI*</div>
<table>
  <tr class="shaded"><td class="lbl shaded" style="width:35%">Naziv organa koji je izdao rješenje:</td><td class="shaded">${z.ctrr_naziv_organa||'____'}</td></tr>
  <tr class="shaded"><td class="lbl shaded">Broj rješenja:</td><td class="shaded">${z.ctrr_broj_rjesenja||'____'}</td></tr>
  <tr class="shaded"><td class="lbl shaded">Datum izdavanja rješenja:</td><td class="shaded">${formatDatePrint(z.ctrr_datum_rjesenja)||'____'}</td></tr>
  <tr class="shaded"><td class="lbl shaded">Rješenje važi do:</td><td class="shaded">${formatDatePrint(z.ctrr_vazi_do)||'____'}</td></tr>
</table>
<div class="note">*podatke popunjava organ državne uprave nadležan za poslove turizma/nadležni organ lokalne uprave</div>

<div class="section shaded" style="background:#bdbdbd">KATEGORIZACIJA/RE-KATEGORIZACIJA*</div>
<table>
  <tr class="shaded"><td class="lbl shaded" style="width:35%">Rješenje o kategorizaciji / re-kategorizaciji:</td><td class="shaded">Broj: ${z.ctrr_kat_broj||'____'} &nbsp; Datum: ${formatDatePrint(z.ctrr_kat_datum)||'____'} &nbsp; Rok važenja do: ${formatDatePrint(z.ctrr_kat_rok)||'____'}</td></tr>
  <tr class="shaded"><td class="lbl shaded">Nivo kategorije:</td><td class="shaded">${z.ctrr_kat_nivo||'1*  2**  3***  4****  5*****'}</td></tr>
</table>
<div class="note">*popunjava nadležni organ samo za vrstu objekta koji se kategoriše</div>

<div class="section shaded" style="background:#bdbdbd">ĆUTANJE ADMINISTRACIJE (istek roka)*</div>
<table>
  <tr class="shaded"><td class="lbl shaded" style="width:35%">Obavještenje o početku obavljanja djelatnosti:</td><td class="shaded">Broj: ${z.ctrr_obavjestenje_broj||'____'} &nbsp; Datum: ${formatDatePrint(z.ctrr_obavjestenje_datum)||'____'}</td></tr>
</table>
<div class="note">*u slučaju da je obavljanje djelatnosti počelo po osnovu „ćutanja administracije", odnosno isteka roka za odlučivanje po podnešenom zahtjevu - podatke popunjava organ državne uprave nadležan za poslove turizma/nadležni organ lokalne uprave</div>

<table style="margin-top:6px">
  <tr><td class="lbl" style="width:30%">Napomena (ostale informacije/komentar i sl.):</td><td>${z.napomena||'&nbsp;'}</td></tr>
</table>

<div class="sig-area">
  <div>U <span style="border-bottom:1px solid #000;display:inline-block;min-width:80px;padding:0 5px">${z.ctrr_mjesto||''}</span> dana, <span style="border-bottom:1px solid #000;display:inline-block;min-width:90px;padding:0 5px">${formatDatePrint(z.datum_podnosenja)||''}</span> god.</div>
  <div class="sig-row">
    <div>Lice odgovorno za tačnost podataka:</div>
    <div>
      <div class="sig-line">${z.ctrr_lice_odgovorno||'&nbsp;'}</div>
      <div class="small" style="text-align:center">(ime i prezime)</div>
      <div class="sig-line" style="margin-top:14px">&nbsp;</div>
      <div class="small" style="text-align:center">(potpis)</div>
    </div>
  </div>
</div>

<script>window.onload=function(){window.print();window.onafterprint=function(){window.close()}}</script>
</body></html>`;
  };

  const print = (z) => printHTML(buildHtml(z));
  const word = (z) => downloadWord(buildHtml(z), `CTR_Restoran_${(z.ctrr_naziv_objekta||'objekat').replace(/\s+/g,'_')}.doc`);

  const filtered = list.filter(z => {
    if (!search) return true;
    const s = search.toLowerCase();
    return (z.ctrr_naziv_objekta||'').toLowerCase().includes(s)
        || (z.ctrr_naziv_sjediste||'').toLowerCase().includes(s)
        || (z.client_naziv||'').toLowerCase().includes(s);
  });

  return (
    <div className="space-y-4" data-testid="ctr-restorani-page">
      <div className="flex items-center justify-between">
        <div>
          <h2 className="text-xl font-medium text-slate-900 flex items-center gap-2">
            <Storefront size={24} weight="duotone" className="text-orange-600" />
            CTR — Restorani / Barovi / Picerije / Konobe
          </h2>
          <p className="text-sm text-slate-500">Centralni turistički registar — ugostiteljski objekti za pripremanje hrane, pića i napitaka</p>
        </div>
        <Button onClick={() => { setEditing(null); setForm(EMPTY); setOpen(true); }}
          className="bg-orange-600 hover:bg-orange-700 text-white" data-testid="ctr-restoran-add-btn">
          <Plus size={16} className="mr-1" /> Novi obrazac
        </Button>
      </div>

      <Card className="p-3">
        <Input value={search} onChange={(e) => setSearch(e.target.value)}
          placeholder="Pretraga po nazivu objekta, sjedištu ili klijentu..."
          className="max-w-md" data-testid="ctr-restoran-search" />
      </Card>

      <Card className="p-0 overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-slate-50 border-b">
            <tr className="text-left text-xs uppercase font-semibold text-slate-600 tracking-wider">
              <th className="px-3 py-2">Naziv objekta</th>
              <th className="px-3 py-2">Vrsta</th>
              <th className="px-3 py-2">Klijent / Sjedište</th>
              <th className="px-3 py-2">Datum</th>
              <th className="px-3 py-2 text-right">Akcije</th>
            </tr>
          </thead>
          <tbody>
            {filtered.length === 0 && <tr><td colSpan={5} className="text-center py-6 text-slate-400">Nema obrazaca</td></tr>}
            {filtered.map(z => (
              <tr key={z.id} className="border-b border-slate-100 hover:bg-slate-50" data-testid={`ctr-restoran-row-${z.id}`}>
                <td className="px-3 py-2 font-medium">{z.ctrr_naziv_objekta || '—'}</td>
                <td className="px-3 py-2 text-slate-600 text-xs">{z.ctrr_vrsta_objekta || '—'}</td>
                <td className="px-3 py-2 text-slate-600 text-xs">{z.client_naziv || z.ctrr_naziv_sjediste || '—'}</td>
                <td className="px-3 py-2 text-slate-600 text-xs">{formatDatePrint(z.datum_podnosenja)}</td>
                <td className="px-3 py-2 text-right">
                  <div className="inline-flex">
                    <button onClick={() => print(z)} className="p-2 hover:bg-green-100 rounded" title="Štampaj"><Printer size={14} className="text-green-600" /></button>
                    <button onClick={() => word(z)} className="p-2 hover:bg-indigo-100 rounded" title="Word"><FileDoc size={14} className="text-indigo-600" /></button>
                    <button onClick={() => handleEdit(z)} className="p-2 hover:bg-blue-100 rounded" title="Uredi"><Pencil size={14} className="text-blue-600" /></button>
                    <button onClick={() => handleDelete(z)} className="p-2 hover:bg-red-100 rounded" title="Obriši"><Trash size={14} className="text-red-600" /></button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </Card>

      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-5xl max-h-[90vh] overflow-y-auto">
          <DialogHeader><DialogTitle>{editing ? 'Uredi' : 'Novi'} CTR Restoran obrazac</DialogTitle></DialogHeader>

          <div className="space-y-4">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
              <div>
                <Label className="text-xs uppercase font-semibold text-slate-600">Klijent</Label>
                <ClientAutocomplete clients={clients} value={form.client_id} onChange={(id) => onClientChange(id)} testid="ctrr-client-select" placeholder="Pretraga po nazivu ili PIB-u..." />
              </div>
              <div>
                <Label className="text-xs uppercase font-semibold text-slate-600">Datum podnošenja</Label>
                <DateInput value={form.datum_podnosenja} onChange={(v) => setForm({ ...form, datum_podnosenja: v })} />
              </div>
              <div>
                <Label className="text-xs uppercase font-semibold text-slate-600">Mjesto</Label>
                <Input value={form.ctrr_mjesto} onChange={(e) => setForm({ ...form, ctrr_mjesto: e.target.value })} placeholder="ULCINJ" />
              </div>
            </div>

            <div className="border-t pt-3">
              <h4 className="font-semibold text-slate-800 text-sm mb-2">Podaci o objektu</h4>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                <div>
                  <Label className="text-xs">Vrsta objekta</Label>
                  <Input value={form.ctrr_vrsta_objekta} onChange={(e) => setForm({ ...form, ctrr_vrsta_objekta: e.target.value.toUpperCase() })} placeholder="RESTORAN / BAR / KAFIĆ / PICERIJA / KONOBA..." />
                </div>
                <div>
                  <Label className="text-xs">Naziv objekta</Label>
                  <Input value={form.ctrr_naziv_objekta} onChange={(e) => setForm({ ...form, ctrr_naziv_objekta: e.target.value.toUpperCase() })} />
                </div>
                <label className="flex items-center gap-2 text-sm">
                  <input type="checkbox" checked={form.ctrr_club_oznaka} onChange={(e) => setForm({ ...form, ctrr_club_oznaka: e.target.checked })} />
                  „Club" oznaka
                </label>
                <div>
                  <Label className="text-xs">Vrsta unosa</Label>
                  <Select value={form.ctrr_vrsta_unosa} onValueChange={(v) => setForm({ ...form, ctrr_vrsta_unosa: v })}>
                    <SelectTrigger><SelectValue /></SelectTrigger>
                    <SelectContent>
                      <SelectItem value="upis">Upis podataka</SelectItem>
                      <SelectItem value="promjena">Promjena / dopuna</SelectItem>
                      <SelectItem value="prestanak">Prestanak važenja rješenja</SelectItem>
                    </SelectContent>
                  </Select>
                </div>
                <div>
                  <Label className="text-xs">Datum unosa</Label>
                  <DateInput value={form.ctrr_datum_unosa} onChange={(v) => setForm({ ...form, ctrr_datum_unosa: v })} />
                </div>
              </div>
            </div>

            <div className="border-t pt-3">
              <h4 className="font-semibold text-slate-800 text-sm mb-2">Privredno društvo / Preduzetnik</h4>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                <div>
                  <Label className="text-xs">Oblik</Label>
                  <Select value={form.ctrr_oblik} onValueChange={(v) => setForm({ ...form, ctrr_oblik: v })}>
                    <SelectTrigger><SelectValue /></SelectTrigger>
                    <SelectContent>
                      <SelectItem value="preduzetnik">Preduzetnik</SelectItem>
                      <SelectItem value="komanditno">Komanditno društvo</SelectItem>
                      <SelectItem value="doo">D.O.O.</SelectItem>
                      <SelectItem value="ortacko">Ortačko društvo</SelectItem>
                      <SelectItem value="ad">A.D.</SelectItem>
                      <SelectItem value="dio_stranog">Dio stranog društva</SelectItem>
                    </SelectContent>
                  </Select>
                </div>
                <div className="grid grid-cols-2 gap-2">
                  <div><Label className="text-xs">Šifra djelatnosti</Label><Input value={form.ctrr_pretezna_sifra} onChange={(e) => setForm({ ...form, ctrr_pretezna_sifra: e.target.value })} /></div>
                  <div><Label className="text-xs">Naziv djelatnosti</Label><Input value={form.ctrr_pretezna_naziv} onChange={(e) => setForm({ ...form, ctrr_pretezna_naziv: e.target.value })} /></div>
                </div>
                <div><Label className="text-xs">Naziv firme / sjedište</Label><Input value={form.ctrr_naziv_sjediste} onChange={(e) => setForm({ ...form, ctrr_naziv_sjediste: e.target.value })} /></div>
                <div><Label className="text-xs">Matični broj (PIB)</Label><Input value={form.ctrr_maticni_broj} onChange={(e) => setForm({ ...form, ctrr_maticni_broj: e.target.value })} /></div>
                <div><Label className="text-xs">Ulica i broj</Label><Input value={form.ctrr_ulica_broj} onChange={(e) => setForm({ ...form, ctrr_ulica_broj: e.target.value })} /></div>
                <div><Label className="text-xs">Opština i država</Label><Input value={form.ctrr_opstina_drzava} onChange={(e) => setForm({ ...form, ctrr_opstina_drzava: e.target.value })} /></div>
                <div><Label className="text-xs">Odgovorno lice (ime i prezime)</Label><Input value={form.ctrr_odg_ime} onChange={(e) => setForm({ ...form, ctrr_odg_ime: e.target.value })} /></div>
                <div><Label className="text-xs">JMB direktora</Label><Input value={form.ctrr_odg_jmb} onChange={(e) => setForm({ ...form, ctrr_odg_jmb: e.target.value })} /></div>
                <div><Label className="text-xs">Kontakt telefon / email</Label><Input value={form.ctrr_odg_kontakt} onChange={(e) => setForm({ ...form, ctrr_odg_kontakt: e.target.value })} /></div>
              </div>
            </div>

            <div className="border-t pt-3">
              <h4 className="font-semibold text-slate-800 text-sm mb-2">Adresa objekta</h4>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                <div>
                  <Label className="text-xs">Osnov korišćenja</Label>
                  <Select value={form.ctrr_osnov} onValueChange={(v) => setForm({ ...form, ctrr_osnov: v })}>
                    <SelectTrigger><SelectValue /></SelectTrigger>
                    <SelectContent>
                      <SelectItem value="svojina">Svojina</SelectItem>
                      <SelectItem value="zakup">Zakup</SelectItem>
                      <SelectItem value="drugi">Drugi pravni osnov</SelectItem>
                    </SelectContent>
                  </Select>
                </div>
                <div><Label className="text-xs">Drugi osnov (ako da)</Label><Input value={form.ctrr_osnov_drugi} onChange={(e) => setForm({ ...form, ctrr_osnov_drugi: e.target.value })} /></div>
                <div><Label className="text-xs">Ulica i broj</Label><Input value={form.ctrr_obj_ulica_broj} onChange={(e) => setForm({ ...form, ctrr_obj_ulica_broj: e.target.value })} /></div>
                <div><Label className="text-xs">Opština i mjesto</Label><Input value={form.ctrr_obj_opstina_mjesto} onChange={(e) => setForm({ ...form, ctrr_obj_opstina_mjesto: e.target.value })} /></div>
              </div>
              <div className="mt-2 grid grid-cols-2 md:grid-cols-4 gap-2">
                {[
                  ['ctrr_lok_grad','U gradu'],
                  ['ctrr_lok_prigrad','U prigradskom području'],
                  ['ctrr_lok_plaza','U blizini plaže'],
                  ['ctrr_lok_skijaliste','U blizini skijališta'],
                  ['ctrr_lok_nacionalni_park','U blizini nacionalnog parka'],
                ].map(([k,l]) => (
                  <label key={k} className="flex items-center gap-2 text-sm">
                    <input type="checkbox" checked={form[k]} onChange={(e) => setForm({ ...form, [k]: e.target.checked })} />
                    {l}
                  </label>
                ))}
                <Input className="col-span-2" placeholder="Ostalo (upisati)" value={form.ctrr_lok_ostalo} onChange={(e) => setForm({ ...form, ctrr_lok_ostalo: e.target.value })} />
              </div>
            </div>

            <div className="border-t pt-3">
              <h4 className="font-semibold text-slate-800 text-sm mb-2">Odgovorno lice u objektu</h4>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
                <div><Label className="text-xs">Ime i prezime</Label><Input value={form.ctrr_odg_obj_ime} onChange={(e) => setForm({ ...form, ctrr_odg_obj_ime: e.target.value })} /></div>
                <div><Label className="text-xs">JMB</Label><Input value={form.ctrr_odg_obj_jmb} onChange={(e) => setForm({ ...form, ctrr_odg_obj_jmb: e.target.value })} /></div>
                <div><Label className="text-xs">Pol</Label>
                  <Select value={form.ctrr_odg_obj_pol} onValueChange={(v) => setForm({ ...form, ctrr_odg_obj_pol: v })}>
                    <SelectTrigger><SelectValue /></SelectTrigger>
                    <SelectContent><SelectItem value="M">Muški</SelectItem><SelectItem value="Z">Ženski</SelectItem></SelectContent>
                  </Select>
                </div>
                <div className="md:col-span-3"><Label className="text-xs">Kontakt telefon / email</Label><Input value={form.ctrr_odg_obj_kontakt} onChange={(e) => setForm({ ...form, ctrr_odg_obj_kontakt: e.target.value })} /></div>
              </div>
            </div>

            <div className="border-t pt-3">
              <h4 className="font-semibold text-slate-800 text-sm mb-2">Zaposleni i period rada</h4>
              <div className="grid grid-cols-2 md:grid-cols-3 gap-2">
                <div><Label className="text-xs">Stalno - žene</Label><Input type="number" value={form.ctrr_zap_zene_stalno} onChange={(e) => setForm({ ...form, ctrr_zap_zene_stalno: e.target.value })} /></div>
                <div><Label className="text-xs">Stalno - muškarci</Label><Input type="number" value={form.ctrr_zap_musk_stalno} onChange={(e) => setForm({ ...form, ctrr_zap_musk_stalno: e.target.value })} /></div>
                <div><Label className="text-xs">Stalno - ukupno</Label><Input type="number" value={form.ctrr_zap_uk_stalno} onChange={(e) => setForm({ ...form, ctrr_zap_uk_stalno: e.target.value })} /></div>
                <div><Label className="text-xs">Povremeno - žene</Label><Input type="number" value={form.ctrr_zap_zene_povr} onChange={(e) => setForm({ ...form, ctrr_zap_zene_povr: e.target.value })} /></div>
                <div><Label className="text-xs">Povremeno - muškarci</Label><Input type="number" value={form.ctrr_zap_musk_povr} onChange={(e) => setForm({ ...form, ctrr_zap_musk_povr: e.target.value })} /></div>
                <div><Label className="text-xs">Povremeno - ukupno</Label><Input type="number" value={form.ctrr_zap_uk_povr} onChange={(e) => setForm({ ...form, ctrr_zap_uk_povr: e.target.value })} /></div>
              </div>
              <div className="mt-2 flex gap-4 text-sm">
                {[
                  ['ctrr_period_cijela_godina','Tokom cijele godine'],
                  ['ctrr_period_sezonski_ljeti','Sezonski - ljeti'],
                  ['ctrr_period_sezonski_zimi','Sezonski - zimi'],
                ].map(([k,l]) => (
                  <label key={k} className="flex items-center gap-2"><input type="checkbox" checked={form[k]} onChange={(e) => setForm({ ...form, [k]: e.target.checked })} />{l}</label>
                ))}
              </div>
            </div>

            <div className="border-t pt-3">
              <h4 className="font-semibold text-slate-800 text-sm mb-2">Kapacitet</h4>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                <div><Label className="text-xs">Zatvoreni prostor</Label><Input value={form.ctrr_prostor_zatvoreni} onChange={(e) => setForm({ ...form, ctrr_prostor_zatvoreni: e.target.value })} /></div>
                <div><Label className="text-xs">Otvoreni prostor (terasa/bašta)</Label><Input value={form.ctrr_prostor_otvoreni} onChange={(e) => setForm({ ...form, ctrr_prostor_otvoreni: e.target.value })} /></div>
                <div><Label className="text-xs">Ostalo</Label><Input value={form.ctrr_prostor_ostalo} onChange={(e) => setForm({ ...form, ctrr_prostor_ostalo: e.target.value })} /></div>
                <div><Label className="text-xs">Broj konzumnih mjesta</Label><Input type="number" value={form.ctrr_konzumna_mjesta} onChange={(e) => setForm({ ...form, ctrr_konzumna_mjesta: e.target.value })} /></div>
              </div>
            </div>

            <div className="border-t pt-3">
              <h4 className="font-semibold text-slate-800 text-sm mb-2">Sadržaji (broj / kapacitet)</h4>
              {[
                ['ctrr_vinoteka','ctrr_vinoteka_broj','ctrr_vinoteka_kap','Vinoteka'],
                ['ctrr_sank_bar','ctrr_sank_bar_broj','ctrr_sank_bar_kap','Šank bar'],
                ['ctrr_sadrzaj_djeca','ctrr_sadrzaj_djeca_broj','ctrr_sadrzaj_djeca_kap','Sadržaji za djecu'],
              ].map(([flag, brojK, kapK, label]) => (
                <div key={flag} className="grid grid-cols-1 md:grid-cols-4 gap-2 mb-2 items-end">
                  <label className="flex items-center gap-2"><input type="checkbox" checked={form[flag]} onChange={(e) => setForm({ ...form, [flag]: e.target.checked })} />{label}</label>
                  <Input type="number" placeholder="Broj" value={form[brojK]} onChange={(e) => setForm({ ...form, [brojK]: e.target.value })} />
                  <Input placeholder="Kapacitet/veličina" value={form[kapK]} onChange={(e) => setForm({ ...form, [kapK]: e.target.value })} />
                </div>
              ))}
              <div className="grid grid-cols-1 md:grid-cols-3 gap-2">
                <Input placeholder="Ostali sadržaji" value={form.ctrr_sadrzaj_ostalo} onChange={(e) => setForm({ ...form, ctrr_sadrzaj_ostalo: e.target.value })} />
                <Input placeholder="Broj" type="number" value={form.ctrr_sadrzaj_ostalo_broj} onChange={(e) => setForm({ ...form, ctrr_sadrzaj_ostalo_broj: e.target.value })} />
                <Input placeholder="Kapacitet" value={form.ctrr_sadrzaj_ostalo_kap} onChange={(e) => setForm({ ...form, ctrr_sadrzaj_ostalo_kap: e.target.value })} />
              </div>
            </div>

            <div className="border-t pt-3">
              <h4 className="font-semibold text-slate-800 text-sm mb-2">Parking prostor (broj mjesta po vrsti)</h4>
              <div className="grid grid-cols-2 md:grid-cols-4 gap-2">
                <div><Label className="text-xs">Otvoreni</Label><Input type="number" value={form.ctrr_park_otvoreni} onChange={(e) => setForm({ ...form, ctrr_park_otvoreni: e.target.value })} /></div>
                <div><Label className="text-xs">Natkriveni</Label><Input type="number" value={form.ctrr_park_natkriveni} onChange={(e) => setForm({ ...form, ctrr_park_natkriveni: e.target.value })} /></div>
                <div><Label className="text-xs">Garaža</Label><Input type="number" value={form.ctrr_park_garaza} onChange={(e) => setForm({ ...form, ctrr_park_garaza: e.target.value })} /></div>
                <div><Label className="text-xs">Neobiljezeni</Label><Input type="number" value={form.ctrr_park_neobiljezeni} onChange={(e) => setForm({ ...form, ctrr_park_neobiljezeni: e.target.value })} /></div>
              </div>
            </div>

            <div className="border-t pt-3">
              <h4 className="font-semibold text-slate-800 text-sm mb-2">Napomena i potpis</h4>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                <div className="md:col-span-2"><Label className="text-xs">Napomena</Label><textarea className="w-full border rounded p-2" rows={2} value={form.napomena} onChange={(e) => setForm({ ...form, napomena: e.target.value })} /></div>
                <div><Label className="text-xs">Lice odgovorno za tačnost</Label><Input value={form.ctrr_lice_odgovorno} onChange={(e) => setForm({ ...form, ctrr_lice_odgovorno: e.target.value })} /></div>
              </div>
            </div>
          </div>

          <div className="flex justify-end gap-2 pt-4 border-t mt-4">
            <Button variant="outline" onClick={() => setOpen(false)}>Otkaži</Button>
            <Button onClick={handleSave} className="bg-orange-600 hover:bg-orange-700 text-white">Sačuvaj</Button>
          </div>
        </DialogContent>
      </Dialog>
    </div>
  );
}
